import { getFieldTypesList, getLanguageList } from './literals';

export const CUSTOM_LIST_NAMES = Object.freeze({
    FIELD_TYPES: 'CustomListFieldTypes',
    FM_FUNCTION_ARGUMENT_TYPES: 'CustomFMFunctionsArgsTypes',
    LANGUAGES: 'CustomLanguages',
    LOCALE: 'CustomListLocale',
    SFM_TABS: 'CustomSfmTabs',
});

const getCustomLanguages = (t) => {
    const languages = getLanguageList(t);

    return [
        ...languages.slice(0, 2),
        { label: t('cfm_label_ca_es'), value: 'ca-es' },
        ...languages.slice(2),
    ];
};

const getSfmTabs = (t) => [
    { label: t('cfm_label_sfm_intensity'), value: 'intensity' },
    { label: t('cfm_label_sfm_distribution'), value: 'distribution' },
    { label: t('cfm_label_sfm_conversion'), value: 'conversion' },
];

const getFmFunctionArgumentTypes = () =>
    ['boolean', 'number', 'object', 'string', 'string_array'].map((value) => ({
        label: value,
        value,
    }));

const CUSTOM_LIST_FACTORIES = {
    [CUSTOM_LIST_NAMES.FIELD_TYPES]: getFieldTypesList,
    [CUSTOM_LIST_NAMES.FM_FUNCTION_ARGUMENT_TYPES]: getFmFunctionArgumentTypes,
    [CUSTOM_LIST_NAMES.LANGUAGES]: getCustomLanguages,
    [CUSTOM_LIST_NAMES.LOCALE]: getLanguageList,
    [CUSTOM_LIST_NAMES.SFM_TABS]: getSfmTabs,
};

export const getCustomListOptions = (list, t) => CUSTOM_LIST_FACTORIES[list]?.(t) ?? null;
